var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Button from '@doordash/component-button';
import { Icon, StackChildren, Text } from '@doordash/design-language';
import * as React from 'react';
import Dropzone from 'react-dropzone';
import Strings from './Strings';
import { DropArea, FileUploadViewButtonsWrapper } from './styles';
export var FileDropZone = function (_a) {
    var onFileDrop = _a.onFileDrop;
    return (React.createElement(Dropzone, { onDrop: onFileDrop, accept: "image/png, image/jpg, image/jpeg, image/svg" }, function (_a) {
        var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
        return (React.createElement(DropArea, __assign({}, getRootProps({
            refKey: 'innerRef',
        })),
            React.createElement("input", __assign({}, getInputProps())),
            React.createElement(StackChildren, { size: StackChildren.Sizes.XSmall },
                React.createElement(Icon, { size: Icon.Sizes.XLarge, type: Icon.Types.UploadLine, color: Icon.Colors.BorderSecondary }),
                React.createElement(Text, { styles: Text.Styles.Body1Emphasis }, Strings.FileDropZone.dragDropUpload),
                React.createElement(Text, { styles: Text.Styles.Medium12, color: Text.Colors.SystemGrey60 }, Strings.FileDropZone.or),
                React.createElement(FileUploadViewButtonsWrapper, null,
                    React.createElement(Button, { type: Button.Types.Primary, size: Button.Sizes.Small, padding: Button.Padding.Wide }, Strings.FileDropZone.selectFile)))));
    }));
};
